export default function CertCard(props) {
    return (
        <a href={props.img} className="m-4">
            <div data-aos="fade-up" data-aos-duration="500" data-aos-offset="100" className="hover:bg-dark w-11/12 h-[25rem] bg-dark-200 rounded-md py-4 px-4 flex flex-col justify-between min-h-400px m-auto">
                <div>
                    <img src={props.img} className="w-full h-56 mx-auto object-cover" alt={props.name}></img>
                    <div className="mt-2">
                        <h1 className="font-bold md:text-xl">{props.name}</h1>
                        <p className="font-light md:text-lg">Issued by {props.issued}</p>
                    </div>
                </div>
                <div>
                <button className="visit-button hover:bg-red"><a href={props.link} target="_blank" rel="noreferrer" >VIEW</a></button>
                </div>
            </div>
        </a>
    )
}
